<template>
    <div class="sidebar" style="background:#fff">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#fff" text-color="#666666" active-text-color="#4068FC" unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">{{threeItem.title}}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else-if="!subItem.isSuper" :index="subItem.index" :key="subItem.index">{{subItem.title}}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import { getUserType, getMenuList } from '@/assets/js/user';
import bus from '@/assets/js/bus';
export default {
    data() {
        return {
            collapse: false,
            items: []
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });

        let menuList = getMenuList();
        let parentItemList = [];
        let i = 1;
        for (let pmenu of menuList) {
            i++;
            let parentItem = {};
            parentItem['icon'] = pmenu.icon;
            parentItem['index'] = 'parent' + i;
            parentItem['title'] = pmenu.label;
            let subItemList = [];
            for (let smenu of pmenu.children) {
                let subItem = {};
                subItem['icon'] = 'el-icon-refresh';

                let index = smenu.url.replace('/', '_').toLocaleLowerCase();
                subItem['index'] = index;
                subItem['title'] = smenu.label;
                subItemList.push(subItem);
            }
            parentItem['subs'] = subItemList;

            parentItemList.push(parentItem);
        }
        this.items = parentItemList;

        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('goToPage', pageInfo => {
            this.switchModule(pageInfo.moduleName, pageInfo.menuIndex, pageInfo.params);
        });
    },
    methods: {
        switchModule(moduleName, menuIndex, params) {
            let path = `${moduleName}_${menuIndex}`;
            console.log(path);
            if (params) {
                this.$router.push({ path: path, query: params }).catch(err => {
                    err;
                });
            } else {
                this.$router.push(path).catch(err => {
                    err;
                });
            }
        },
        swithToMenu(menuIndex, params) {
            if (!menuIndex) {
                console.log(this.items, this.items ? this.items[0] : 'noItems', this.items[0].subs);
                let idx = this.items[0].subs && this.items[0].subs.length > 0 ? this.items[0].subs[0].index : this.items[0].index;

                menuIndex = idx.indexOf('/') === 0 ? idx : '/' + idx;
            }
            console.log(this.currencyMenuIndex, menuIndex);
            if (this.currencyMenuIndex != menuIndex) {
                this.currencyMenuIndex = menuIndex;
                this.$router.push(menuIndex);
                if (params) {
                    this.$router.push({ path: menuIndex, query: params }).catch(err => {
                        err;
                    });
                } else {
                    this.$router.push(menuIndex).catch(err => {
                        err;
                    });
                }
            }
        }
    }
};
</script>
<style lang="less">
.el-submenu__icon-arrow{
    font-size: 16px!important;
}
</style>